import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import AppHeader from './AppHeader';

export default function Help() {
  const theme = useTheme();
  return (

    <Box
      sx={{
        height: '100%',
        width: '100%',
        backgroundColor: '#3B4E68',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: '20px',
        contain: 'size',
      }}
    >

      <Box>
        <AppHeader />
      </Box>

      {/* <Box> */}
      <Typography
        variant='body1'
        sx={{
          color: '#FFFFFF',
          fontSize: '24px',
          fontWeight: 'bold',
          textAlign: 'left',
          paddingLeft: '20px',
          paddingBottom: '10px',
          backgroundColor: '#3B4E68',
        }}
      >
        Help
      </Typography>
      <Box
        sx={{
          overflowX: 'scroll',
          backgroundColor: '#3B4E68',
          // contain: 'size',
        }}
      >
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon
              sx={{
                backgroundColor: '#3B4E68',
                color: '#FFFFFF',
              }}
            />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{
              backgroundColor: '#3B4E68',
              color: '#FFFFFF',
            }}
          >
            <Typography
              variant='body1'
              sx={{
                color: '#FFFFFF',
                fontSize: '24px',
                fontWeight: 'bold',
                textAlign: 'left',
                paddingLeft: '20px',
                paddingBottom: '10px',
              }}
            >
              Register Your Pattern
            </Typography>
          </AccordionSummary>

          <AccordionDetails
            sx={{
              backgroundColor: '#3B4E68',
            }}
          >
            <Typography
              variant='body1'
              sx={{
                color: '#FFFFFF',
                fontSize: '14px',
                textAlign: 'left',
                paddingLeft: '20px',
              }}
            >
              Registering your pattern is a <b>two-step process</b>:
            </Typography>

            <Typography
              variant='body1'
              sx={{
                color: '#FFFFFF',
                textAlign: 'left',
                fontWeight: 'bold',
                fontSize: '18px',
                padding: '20px',
                paddingBottom: '0px',
              }}
            >
              Step 1: Choose a pairing cell
            </Typography>

            <Box sx={{
              color: '#FFFFFF',
              fontSize: '14px',
              textAlign: 'left',
              paddingLeft: '20px',
            }}
            >
              <List
                sx={{
                  listStyle: 'decimal',
                  paddingLeft: '20px',
                  // [`& li.MuiListItem-root::marker`]: {
                  //   color: 'red',
                  // }
                }}
              >
                <ListItem
                  sx={{
                    display: 'list-item',
                    paddingLeft: '5px',
                  }}
                >
                  Choose a pairing cell from the top row.
                </ListItem>
                <ListItem
                  sx={{
                    display: 'list-item',
                    paddingLeft: '5px',
                  }}
                >
                  To change your pairing cell, simply select a different one. The previous selection will be cancelled, and the new cell will be highlighted.
                </ListItem>
                <ListItem
                  sx={{
                    display: 'list-item',
                    paddingLeft: '5px',
                  }}
                >
                  Memorise the position of your pairing cell. You will need to recall it when signing in.
                </ListItem>
              </List>
            </Box>

            <Typography
              variant='body1'
              sx={{
                color: '#FFFFFF',
                textAlign: 'left',
                fontWeight: 'bold',
                fontSize: '18px',
                padding: '20px',
                paddingBottom: '0px',
              }}
            >
              Step 2: Draw your pattern on the grid
            </Typography>

            <Box sx={{
              color: '#FFFFFF',
              fontSize: '14px',
              textAlign: 'left',
              paddingLeft: '20px',
            }}
            >
              <List
                sx={{
                  listStyle: 'decimal',
                  paddingLeft: '20px',
                  // [`& li.MuiListItem-root::marker`]: {
                  //   color: 'red',
                  // }
                }}
              >
                <ListItem
                  sx={{
                    display: 'list-item',
                    paddingLeft: '5px',
                  }}
                >
                  Draw your pattern by selecting any six cells in the 6x6 grid.
                </ListItem>
                <ListItem
                  sx={{
                    display: 'list-item',
                    paddingLeft: '5px',
                  }}
                >
                  Each time you select a cell:
                </ListItem>
                <ListItem
                  sx={{
                    display: 'list-item',
                    paddingLeft: '5px',
                  }}
                >
                  It will be highlighted with a border.
                </ListItem>
                <ListItem
                  sx={{
                    display: 'list-item',
                    paddingLeft: '5px',
                  }}
                >
                  The dot inside will change to a number indicating the cell’s order in your pattern.
                </ListItem>
                <ListItem
                  sx={{
                    display: 'list-item',
                    paddingLeft: '5px',
                  }}
                >
                  If you select the same cell again, multiple numbers will appear inside the cell.
                </ListItem>
                <ListItem
                  sx={{
                    display: 'list-item',
                    paddingLeft: '5px',
                  }}
                >
                  You can reset your pattern at any time to start again.
                </ListItem>
                <ListItem
                  sx={{
                    display: 'list-item',
                    paddingLeft: '5px',
                  }}
                >
                  Once you are happy with your pattern, press ‘Review’ to remind yourself of the sequence of the selected cells.
                </ListItem>
                <ListItem
                  sx={{
                    display: 'list-item',
                    paddingLeft: '5px',
                  }}
                >
                  To ensure you can recall your pattern, press ‘Test Pattern’ – this will take you to the sign-in page where you can try signing in.
                </ListItem>
                <ListItem
                  sx={{
                    display: 'list-item',
                    paddingLeft: '5px',
                  }}
                >
                  When you are satisfied, press ‘Save Pattern’ to encrypt the challenge token, making it ready for your next sign-in request.
                </ListItem>
              </List>

            </Box>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon
              sx={{
                backgroundColor: '#3B4E68',
                color: '#FFFFFF',
              }}
            />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{
              backgroundColor: '#3B4E68',
              color: '#FFFFFF',
            }}
          >
            <Typography
              variant='body1'
              sx={{
                color: '#FFFFFF',
                fontSize: '24px',
                fontWeight: 'bold',
                textAlign: 'left',
                paddingLeft: '20px',
                paddingBottom: '10px',
              }}
            >
              Signing In with Gridvault
            </Typography>
          </AccordionSummary>

          <AccordionDetails
            sx={{
              backgroundColor: '#3B4E68',
            }}
          >

            <Box sx={{
              color: '#FFFFFF',
              fontSize: '14px',
              textAlign: 'left',
              paddingLeft: '20px',
            }}
            >
              <List
                sx={{
                  listStyle: 'decimal',
                  paddingLeft: '20px',
                  paddingTop: '0px',
                  // [`& li.MuiListItem-root::marker`]: {
                  //   color: 'red',
                  // }
                }}
              >
                <ListItem
                  sx={{
                    paddingTop: '0px',
                    display: 'list-item',
                    paddingLeft: '5px',
                  }}
                >
                  On the <b>sign-in screen</b>, you will see the <b>pairing row</b> at the top. Each cell in this row has a dark border and contains a random number.
                </ListItem>

                <ListItem
                  sx={{
                    display: 'list-item',
                    paddingLeft: '5px',
                  }}
                >
                  Recall the position of your <b>pairing cell</b> from registration and <b>note the number</b> in that cell.
                </ListItem>
                <ListItem
                  sx={{
                    display: 'list-item',
                    paddingLeft: '5px',
                  }}
                >
                  Using your <b>memorised pattern</b>, locate each cell in the <b>6x6 grid</b> in the correct sequence.
                </ListItem>
                <ListItem
                  sx={{
                    display: 'list-item',
                    paddingLeft: '5px',
                  }}
                >
                  For each cell:
                  <List
                    sx={{
                      listStyle: 'circle',
                    }}
                  >
                    <ListItem
                      sx={{
                        display: 'list-item',
                        paddingLeft: '5px',
                      }}
                    >
                      Use the <b>'+' or '-'</b> buttons to adjust the number in that cell until it matches the number in your <b>pairing cell</b>.
                    </ListItem>
                    <ListItem
                      sx={{
                        display: 'list-item',
                        paddingLeft: '5px',
                      }}
                    >
                      Press <b>'SELECT'</b> to confirm the match.
                    </ListItem>
                    <ListItem
                      sx={{
                        display: 'list-item',
                        paddingLeft: '5px',
                      }}
                    >
                      Move to the next cell in your pattern and repeat the process.
                    </ListItem>
                  </List>
                </ListItem>

                <ListItem
                  sx={{
                    display: 'list-item',
                    paddingLeft: '5px',
                  }}
                >
                  Once all cells have been entered, press <b>'UNLOCK'</b> to complete authentication.
                </ListItem>
              </List>
            </Box>

          </AccordionDetails>
        </Accordion>


      </Box >
    </Box>

  );
}